export default "__VITE_ASSET__BPaejzu1__"